export const userRoles = {
  SUPER_ADMIN: "SUPER_ADMIN",
  SURGEON: "MS", //surgeon
  D_C: "DIC", //director in chief
  STAFF: "MEDANTA_STAFF",
};

export const userStatus = {
  DRAFTED: "DRAFTED",
  SUBMITTED: "SUBMITTED",
  QUERY_RAISED: "QUERY_RAISED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FOLLOW_UP_ONE: "FOLLOW_UP-1",
  FOLLOW_UP_THREE: "FOLLOW_UP-3",
  FOLLOW_UP_SEVEN: "FOLLOW_UP-7",
  FOLLOW_UP_FIFTEEN: "FOLLOW_UP-15",
  ADMITTED: "ADMITTED",
  NOT_ADMITTED: "NOT_INTERESTED",
  EXPIRED: "EXPIRED",
  DISCHARGED: "DISCHARGED",
  LAMA: "LAMA",
  CLOSED: "CLOSED",
  ESTIMATE_APPROVAL_REQUEST: "ESTIMATE_APPROVAL_REQUEST",
  ESTIMATE_APPROVED: "ESTIMATE_APPROVED",
  ESTIMATE_QUERY_RAISED: "QUERY_RAISED_ON_ESTIMATE",
  ENHANCE_APPROVAL_REQUEST: "ENHANCE_APPROVAL_REQUEST",
  ENHANCE_APPROVED: "ENHANCE_APPROVED",
  QUERY_RAISED_ON_ENHANCE: "QUERY_RAISED_ON_ENHANCE",
};

export const responseStatus = {
  RESPONDED: "RESPONDED",
  NOT_RESPONDED: "NOT RESPONDED",
};
